export enum SupportType {
  Telegram = 'Telegram',
  Max = 'Max',
}
